var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 0.799805C8.33142 0.799805 8.60005 1.06843 8.60005 1.3998V7.39981H14.6C14.9314 7.39981 15.2 7.66843 15.2 7.9998C15.2 8.33118 14.9314 8.5998 14.6 8.5998H8.59945L8.60005 14.5998C8.60005 14.9312 8.33142 15.1998 8.00005 15.1998C7.66868 15.1998 7.40005 14.9312 7.40005 14.5998L7.39945 8.5998H1.40005C1.06868 8.5998 0.800049 8.33118 0.800049 7.9998C0.800049 7.66843 1.06868 7.39981 1.40005 7.39981H7.40005V1.3998C7.40005 1.06843 7.66868 0.799805 8.00005 0.799805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.800a60beb51da12477923d571f824ff1.svg";
export { ForwardRef as ReactComponent };